export default "__VITE_ASSET__4695ae77__"